<script>
    import * as CONST from "../../const";
    export let price = 0.0;
</script>

<span id="fixed_total_price">
    <a href="#" class={`${CONST.CLASS_PREFIX}price`}>{price}</a>
</span>
